module.exports = __webpack_public_path__ + "static/img/authenticationSuccess.30e3e62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/authenticationSuccess.png
// module id = SmHf
// module chunks = 1